import { useCallback, useState } from "react";

export const useContactUsThanksModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openThanksModal = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeThanksModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    return {
        isThanksModalOpen: isOpen,
        openThanksModal,
        closeThanksModal,
    };
};
